import { Icd } from '../containers/my-central/patientService';
import { OriginEnum } from './medicine';
import { CID10Estruturado } from './structuredIcd';

export enum MEDICAL_CERTIFICATE_DOCUMENT_TYPE {
  MEDICAL_CERTIFICATE = 'ATESTADO',
  DECLARATION_OF_ATTENDANCE = 'DECLARACAO_DE_COMPARECIMENTO',
  DECLARATION_OF_COMPANION = 'DECLARACAO_DE_ACOMPANHANTE',
  COMPANION_MEDICAL_CERTIFICATE = 'ATESTADO_DE_ACOMPANHANTE',
}

export const MEDICAL_CERTIFICATE_TYPES = {
  CRM: 'Atestado Médico',
  CFM: 'Atestado Médico',
  CRO: 'Atestado Odontológico',
  CFO: 'Atestado Odontológico',
  [MEDICAL_CERTIFICATE_DOCUMENT_TYPE.DECLARATION_OF_COMPANION]: 'Declaração de Acompanhante',
  [MEDICAL_CERTIFICATE_DOCUMENT_TYPE.DECLARATION_OF_ATTENDANCE]: 'Declaração de Comparecimento',
  [MEDICAL_CERTIFICATE_DOCUMENT_TYPE.COMPANION_MEDICAL_CERTIFICATE]: 'Atestado de Acompanhante',
};

export interface MedicalCertificate {
  idPrescricaoAtestado: number;
  DataInicio: string;
  DataTermino: string;
  DataAtestado: string;
  Texto: string;
  Periodo: string;
  TipoPeriodo: string;
  TextoCompleto?: string;
  ConsentimentoCID?: boolean;
  CID10Estruturado?: CID10Estruturado[];
  CID10EstruturadoSecundarios?: CID10Estruturado[];
  Observacao?: string;
  CampoLivre: boolean;
  TextoConsentimento: string;
  idPrescricao: number;
  DeclaracaoComparecimento: boolean;
  Tipo: MEDICAL_CERTIFICATE_DOCUMENT_TYPE;
  Origem?: OriginEnum;
  AdicionadoPorIA?: boolean;
}

export interface MedicalCertificateDTO {
  icd: Icd | null;
  isFreeText: boolean;
  medicalCertificateDate: string;
  startDate: string;
  endDate: string;
  medicalCertificateId: number;
  period: string;
  observation: string;
  text: string;
  consentText: string;
  restPeriodType: string;
  hasConsent: boolean;
  isDeclarationOfAttendance: boolean;
  type: MEDICAL_CERTIFICATE_DOCUMENT_TYPE;
  secondaryIcds: Icd[];
}
